//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import mailgo from 'mailgo';
export default {
  props: {
    items: {
      type: Array,
      required: true,
      default: () => [],
    },
  },
  created() {
    if (process.client) {
      mailgo();
    }
  },
  methods: {
    stripped(href = '') {
      return href.replace(/^mailto:/, '').replace(/^tel:/, '');
    },
    splits(href) {
      return this.stripped(href).split('@');
    },
    hasSplits(href) {
      return this.splits(href).length > 1;
    },
    url(href) {
      return this.hasSplits(href) || this.isTel(href) ? '#mailgo' : href;
    },
    address(href) {
      return this.hasSplits(href) ? this.splits(href)[0] : undefined;
    },
    domain(href) {
      return this.hasSplits(href) ? this.splits(href)[1] : undefined;
    },
    isTel(href = '') {
      return href.startsWith('tel:');
    },
    tel(href) {
      return this.isTel(href) ? this.stripped(href) : undefined;
    },
  },
};
